<template>
    <section class="section configView">
        <h1 class="title is-4 has-text-centered"><font-awesome-icon icon="cog"/> Configuración</h1>
        <Panel title="Cambiar Nombre y foto de Perfil" icon="user">
            <div class="panel-block is-block">
                <p>Para cambiar tu nombre y tu foto de perfil puedes hacerlo con una de tus cuentas sociales <font-awesome-icon :icon="['fab','facebook-square']" /> <font-awesome-icon :icon="['fab','google']" /></p>
                <div class="columns is-centered">
                    <div class="column is-3 has-text-centered">
                        <div class="card">
                            <div class="card-image">
                                <figure class="image is-1by1">
                                    <img :src="user.user.image" alt="">
                                </figure>
                            </div>
                            <div class="card-content">
                                <p class="title is-5">{{ user.user.name  }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="column is-3">
                        <div class="buttons is-centered">
                            <FacebookLoginButton v-on:success="fbSuccess" v-on:failed="fbFailed" text="Facebook"  />
                            <GoogleLoginButton v-on:success="googleSuccess" v-on:error="googleFailed" text="Google" />
                        </div>
                    </div>
                </div>
            </div>
        </Panel>
        <Panel title="Notificaciones" icon="paper-plane">
            <div class="panel-block is-block">
                <p>Habilita las notificaciones para estar al tanto de tus quinielas y eventos que suceden en Quinielazo, como cuando se agregan nuevos partidos o quinielas públicas, etc. etc.</p>
                <Notificable texto="Notíficame en este dispositivo de los eventos de Quinielazo" />
            </div>
        </Panel>
        <Panel :title="user.user.pass ? 'Cambiar contraseña':'Establecer contraseña'" icon="key">
            <div class="panel-block is-block">
                <article class="message is-warning" v-if="!user.user.pass">
                    <div class="message-body">
                        No podras iniciar sesión con contraseña en Quinielazo hasta que establezcas una
                    </div>
                </article>
                <form action="" @submit.prevent="changePass">
                    <div class="field" v-if="user.user.pass">
                        <div class="control has-icons-left">
                            <input class="input" :class="errors.password_actual ? 'is-danger' : ''" v-model="password_actual" type="password" placeholder="Contraseña actual"/>

                            <span class="icon is-small is-left">
                                <font-awesome-icon icon="lock" />
                            </span>
                        </div>
                        <p v-for="(error, key) in errors.password_actual" :key="key" class="help is-danger">
                            {{ error }}
                        </p>
                    </div>
                    <div class="field">
                        <div class="control has-icons-left">
                            <input class="input" :class="errors.password_nueva ? 'is-danger' : ''" v-model="password_nueva" type="password" placeholder="Nueva contraseña.."/>

                            <span class="icon is-small is-left">
                                <font-awesome-icon icon="lock" />
                            </span>
                        </div>
                        <p v-for="(error, key) in errors.password_nueva" :key="key" class="help is-danger">
                            {{ error }}
                        </p>
                    </div>
                    <div class="field">
                        <div class="control has-icons-left">
                            <input class="input" :class="errors.password_nueva_confirmation ? 'is-danger' : ''" v-model="password_nueva_confirmation" type="password" placeholder="Confirma tu Nueva contraseña.."/>

                            <span class="icon is-small is-left">
                                <font-awesome-icon icon="lock" />
                            </span>
                        </div>
                        <p v-for="(error, key) in errors.password_nueva_confirmation" :key="key" class="help is-danger">
                            {{ error }}
                        </p>
                    </div>
            
                    <div class="control">
                        <button class="button is-info is-fullwidth" :disabled="passChanged" v-if="user.user.pass">Cambiar contraseña</button>
                        <button class="button is-info is-fullwidth" :disabled="passChanged" v-if="!user.user.pass">Establecer contraseña</button>
                    </div>
                </form>
            </div>
        </Panel>
    </section>
</template>

<script>
import Panel from '@/components/Panel'
import Notificable from '@/components/Notificable'
import { mapState } from 'vuex'
import FacebookLoginButton from '@/components/FacebookLoginButton'
import GoogleLoginButton from '@/components/GoogleLoginButton'

export default {
    components: { Panel, Notificable, FacebookLoginButton, GoogleLoginButton },
    name: 'Configuracion',
    data() {
        return {
            password_actual: null,
            password_nueva: null,
            password_nueva_confirmation: null,
            errors: [],
            passChanged: false
        }
    },
    methods: {
        changePass(){
            this.errors = []
            this.$store.dispatch('user/changePassword', {
                password_actual: this.password_actual, 
                password_nueva: this.password_nueva, 
                password_nueva_confirmation: this.password_nueva_confirmation
            })
            .then(resp => {
                console.log(resp)
                if(resp != undefined && resp.response != undefined){
                    this.errors = resp.response.data
                }else{
                    this.clearPass()
                }
            })
        },
        clearPass(){
            this.password_actual = null
            this.password_nueva = null
            this.password_nueva_confirmation = null
            this.passChanged = true
        },
        fbSuccess(){
            //Traer info usuario
            window.FB.api('me?fields=email,name', user => {
                //Actualizar usuario
                this.$store.dispatch('user/updateUserProfile', {
                    name: user.name, 
                    image: 'https://graph.facebook.com/v3.3/'+user.id+'/picture?type=large'
                })
                .then(resp => {
                    console.log(resp)
                })
            })
        },
        fbFailed(){
            this.$store.dispatch("notification/add",
			{
				type: "error",
				message: "No se pudo conectar a Facebook"
			},
			{ root: true });
        },
        googleSuccess(guser){
            let google = guser.getBasicProfile()
            console.log(google.getName())
            //Actualizar usuario
            this.$store.dispatch('user/updateUserProfile', {
                name: google.getName(), 
                image: google.getImageUrl()
            })
            .then(resp => {
                console.log(resp)
            })
        },
        googleFailed(){
            this.$store.dispatch("notification/add",
			{
				type: "error",
				message: "No se pudo conectar a Google"
			},
			{ root: true });
        }
    },
    computed: mapState('user',['user'])
}
</script>

<style lang="css" scoped>
.configView{
    padding: 1rem;
}
.panel-block > p{
    margin-bottom: 1em;
}
.card{
    max-width: 250px;
    margin: auto;
}
</style>